import './Auth.scss'
import React, { Component } from 'react'
import { Slide } from '@material-ui/core'
import { uniqueNamesGenerator, adjectives, animals } from 'unique-names-generator'
import Svort, { Status, ButtonArrow, LoginType } from '@svort/component'

import { Translated } from '../../utils/translated'

import Start from '../../components/Start/Start'
import Sign from '../../components/Sign/Sign'
import Stepper from '../../components/Stepper/Stepper'
import LoginFinder from '../../components/LoginFinder/LoginFinder'
import Private from '../Private/Private'

class Auth extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isStart: false,
            isSvort: false,
            isSign: false,
            isLoginFinder: false,
            isPrivate: false,
            isFinish: false,

            isSignIn: this.props.isSignIn,
            login: null,
            activeStep: 0,

            status: ''
        }

        this.initState = this.state;
        this.baseRadius = Math.max(window.outerHeight, window.innerHeight) * 0.45 / 2;
    }

    componentDidMount() {
        const { isDummy, isLoginless, isLiveness, isSignIn } = this.props;

        this.setState({
            isStart: !isDummy && !isLoginless && !isLiveness,
            isSvort: isDummy || isLiveness,
            isLoginFinder: isLoginless,
            isSignIn: isSignIn,
        });
    }

    onStart = (isSignIn) => {
        this.setState({
            isSignIn,
            isStepper: !isSignIn,
            isStart: false,
            isSign: true
        });
    }

    onSign = async (login) => {
        if (!login)
            return

        this.setState({
            login,
            isSign: false,
            isSvort: true,
            activeStep: 1
        });
    }

    onLoginFound = (login) => {
        this.setState({
            login,
            isLoginFinder: false,
            isLogout: false,
            // isSignIn: true,
            // isSvort: true
            isPrivate: true
        });
    }

    onLoginNotFound = () => {
        const login = uniqueNamesGenerator({
            dictionaries: [adjectives, animals],
            length: 2,
            separator: ' ',
            style: 'capital'
        });

        this.setState({
            login,
            isLoginFinder: false,
            isLogout: false,
            isSignIn: false,
            isSvort: true
        });
    }

    onSvortSuccess = (data) => {
        console.log('svort_success', data);

        if (this.props.isLoginless && !this.state.isSignIn)
            this.setState({
                isSvort: false,
                isLoginFinder: true,
                secret: data.key
            })
        else if (this.props.isLoginless)
            this.setState({
                isSvort: false,
                isPrivate: true
            })
        else this.setState({
            isSvort: false,
            isFinish: true,
            status: "app.status.success",
            activeStep: this.state.isSignIn ? 3 : 2
        })
    }

    onSvortError = (error, message) => {
        console.log('svort_error:', error, message);
    }

    onRetry = () => {
        const { isDummy, isLoginless, isLiveness, isSignIn } = this.props;

        this.setState({
            ...this.initState,
            isStart: !isDummy && !isLoginless && !isLiveness,
            isSvort: isDummy || isLiveness,
            isLoginFinder: isLoginless,
            isSignIn: isSignIn,
        });
    }

    onFinish = () => {
        // (!this.ws || this.ws.readyState !== 1) && this.initWebSocket();
        this.props.isDummy || this.props.isLoginless
            ? this.props.history.push('/feature')
            : this.state.isSignIn
                ? this.props.history.push('/main')
                : this.setState({
                    isFinish: false,
                    isSignIn: true,
                    isSvort: true
                });
    }

    onLogout = () => {
        this.setState({
            isPrivate: false,
            isLoginFinder: true,
            login: null,
            isLogout: true
        });
    }

    render() {
        return (
            <div className='auth'>
                <Slide in={!this.state.isSign && !this.props.isDummy && this.state.isStepper} direction={'down'} timeout={{ enter: 500, exit: 500 }} mountOnEnter unmountOnExit>
                    <div>
                        <Stepper
                            isShow={!this.props.isDummy && !this.state.isStart}
                            steps={[
                                <Translated id="app.auth.steps1" />,
                                <Translated id="app.auth.steps2" />,
                                <Translated id="app.auth.steps3" />,
                            ]}
                            activeStep={this.state.activeStep} />
                    </div>
                </Slide>

                {!this.state.isStart && !this.state.isSign && !this.props.isDebug && (this.props.isDummy || !this.state.isStepper) &&
                    <div className='header'>
                        {this.props.isLiveness && this.props.loginType === LoginType.Distortion
                            ? <Translated id="app.auth.distortion" />
                            : this.props.isLiveness && this.props.loginType === LoginType.Emotions
                                ? <Translated id="app.auth.liveness" />
                                : this.props.isLoginless
                                    ? <Translated id="app.auth.loginless" />
                                    : this.state.isSignIn
                                        ? <Translated id={`app.auth.sign-in.${this.props.loginType}`} />
                                        : <Translated id={`app.auth.register.${this.props.registerType}`} />}
                    </div>}

                <div className={`content${!this.state.isStart && !this.state.isSign ? (this.props.isDummy || !this.state.isStepper ? ' with-header' : ' with-stepper') : ''}`}>
                    <Start
                        isShow={this.state.isStart}
                        onStart={this.onStart}
                        direction={'right'} />

                    <Sign
                        isShow={this.state.isSign}
                        isSignIn={this.state.isSignIn}
                        onSign={this.onSign}
                        direction={this.state.isSign ? 'left' : 'right'} />

                    {this.state.isLoginFinder &&
                        <LoginFinder
                            isShow={this.state.isLoginFinder}
                            isLogout={this.state.isLogout}
                            login={this.state.login}
                            secret={this.state.secret}
                            onLoginFound={this.onLoginFound}
                            onLoginNotFound={this.onLoginNotFound}
                            onError={this.onSvortError} />}

                    <Slide in={this.state.isSvort} direction={this.state.isSvort ? 'left' : 'right'} timeout={{ enter: 800, exit: 500 }} mountOnEnter unmountOnExit>
                        <div>
                            <Svort
                                isShow={!this.state.isRetry}
                                login={this.state.login || this.props.login}

                                // wsEndpoint={`wss://${window.location.host}/api`}

                                operationType={this.state.isSignIn ? 'login' : 'register'}
                                registerType={this.props.registerType}
                                loginType={this.props.loginType}
                                locale={this.props.locale}

                                isDebug={this.props.isDebug}
                                isDummy={this.props.isDummy}
                                isLiveness={this.props.isLiveness}
                                baseRadius={this.baseRadius}
                                delay={this.props.delay}

                                onSuccess={this.onSvortSuccess}
                                onError={this.onSvortError}
                            // onStatus={(status) => {
                            //     return 'sd_' + status
                            // }}
                            />
                        </div>
                    </Slide>

                    {this.state.isPrivate &&
                        <Private
                            isShow={this.state.isPrivate}
                            login={this.state.login}
                            onLogout={this.onLogout} />}

                    <Status
                        isShow={this.state.isFinish}
                        isFinish={this.state.isFinish}

                        // direction={this.state.isFinish ? 'left' : 'right'}
                        majorButton={(this.props.isDummy || this.state.isSignIn)
                            ? <ButtonArrow
                                text={<Translated id="app.button.finish" />}
                                onClick={this.onFinish} />
                            : <ButtonArrow
                                text={<Translated id="app.auth.test-sign-in" />}
                                onClick={this.onFinish} />}
                        minorButton={(this.props.isDummy || this.state.isSignIn) &&
                            <ButtonArrow
                                text={<Translated id="app.button.again" />}
                                isArrow={false}
                                isSmall={true}
                                onClick={this.onRetry} />}>
                        {this.state.status}
                    </Status>
                </div>
            </div>
        )
    }
}

export default Auth
